import { tv as e } from "tailwind-variants";
import { jsx as t } from "react/jsx-runtime";
//#region src/components/Text/Text.tsx
var n = e({
	base: "text-ic-text font-ic-body",
	variants: { size: {
		base: "text-base",
		xs: "text-xs"
	} },
	defaultVariants: { size: "base" }
});
function r({ as: e, className: r, size: i, ...a }) {
	return /* @__PURE__ */ t(e ?? "p", {
		...a,
		className: n({
			size: i,
			className: r
		})
	});
}
//#endregion
export { r as Text, n as textVariants };
